import {
    AbstractDataProviderEntityActionParamInterface,
    SEARCH_TYPE_VALUE_TYPE_FIELD,
    SEARCH_TYPE_VALUE_TYPE_STATIC
} from "~/cabinet/vue/client/events/action/types/dataProvider/AbstractDataProviderActionParamInterface";
import {
    DataProviderEntitySaveSearchModeInterface
} from "~/cabinet/ts/data/events/actionDescriptions/DataProvider/Interface";

export default function toggleSearchType(model: AbstractDataProviderEntityActionParamInterface, searchType: DataProviderEntitySaveSearchModeInterface, fieldsAvailable: boolean, value: boolean) {
    let id = searchType.id;
    if (!model.searchTypes[id]) {
        model.searchTypes[id] = {
            enabled: false,
            value: searchType.defaultValue ?? "",
            fieldId: null,
            valueTypeId: SEARCH_TYPE_VALUE_TYPE_STATIC
        };

        if (fieldsAvailable && searchType.fieldId) {
            model.searchTypes[id].fieldId = searchType.fieldId;
            model.searchTypes[id].valueTypeId = SEARCH_TYPE_VALUE_TYPE_FIELD;
        }
    }
    model.searchTypes[id].enabled = value;
}